module.exports = __webpack_public_path__ + "static/media/vuka-logo-light.398e3722.svg";